import React from "react";
import styles from '../ProfilePage.module.css';

const PasswordChange = ({
    error,
    successMessage,
    showPasswordFields,
    togglePasswordFields,
    handlePasswordSave,
    handlePasswordChange,
    passwords,
    showPassword,
    setShowPassword,
    isUpdating
}) => {
    return (
        <>
            {/* Error and Success Messages */}
            {error && !showPasswordFields && <div className={styles.errorMessage}>{error}</div>}
            {successMessage && !showPasswordFields && <div className={styles.successMessage} style={{ textAlign: 'center' }}>{successMessage}</div>}

            {/* Change Password Toggle */}
            <button
                type="button"
                className={styles.passwordToggleButton}
                onClick={togglePasswordFields}
            >
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
                    <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
                </svg>
                {showPasswordFields ? 'Cancel Password Change' : 'Change Password'}
            </button>

            {/* Password Change Section */}
            {showPasswordFields && (
                <div className={styles.passwordSection}>
                    <h3 className={styles.sectionTitle}>Change Your Password</h3>

                    {error && <div className={styles.errorMessage}>{error}</div>}
                    {successMessage && <div className={styles.successMessage}>{successMessage}</div>}

                    <form onSubmit={handlePasswordSave}>
                        <div className={styles.formGroup}>
                            <label htmlFor="current">Current Password</label>
                            <div className={styles.passwordInput}>
                                <input
                                    id="current"
                                    type={showPassword ? 'text' : 'password'}
                                    name="current"
                                    value={passwords.current}
                                    onChange={handlePasswordChange}
                                    required
                                    autoComplete="current-password"
                                />
                                <button
                                    type="button"
                                    className={styles.visibilityToggle}
                                    onClick={() => setShowPassword(!showPassword)}
                                    aria-label={showPassword ? 'Hide password' : 'Show password'}
                                >
                                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                        {showPassword ? (
                                            <>
                                                <path d="M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7Z"></path>
                                                <circle cx="12" cy="12" r="3"></circle>
                                            </>
                                        ) : (
                                            <>
                                                <path d="M9.88 9.88a3 3 0 1 0 4.24 4.24"></path>
                                                <path d="M10.73 5.08A10.43 10.43 0 0 1 12 5c7 0 10 7 10 7a13.16 13.16 0 0 1-1.67 2.68"></path>
                                                <path d="M6.61 6.61A13.526 13.526 0 0 0 2 12s3 7 10 7a9.74 9.74 0 0 0 5.39-1.61"></path>
                                                <line x1="2" x2="22" y1="2" y2="22"></line>
                                            </>
                                        )}
                                    </svg>
                                </button>
                            </div>
                        </div>

                        <div className={styles.formGroup}>
                            <label htmlFor="newPassword">New Password</label>
                            <input
                                id="newPassword"
                                type={showPassword ? 'text' : 'password'}
                                name="newPassword"
                                value={passwords.newPassword}
                                onChange={handlePasswordChange}
                                required
                                minLength="8"
                                autoComplete="new-password"
                            />
                            <small>Must be at least 8 characters</small>
                        </div>

                        <div className={styles.formGroup}>
                            <label htmlFor="confirmPassword">Confirm New Password</label>
                            <input
                                id="confirmPassword"
                                type={showPassword ? 'text' : 'password'}
                                name="confirmPassword"
                                value={passwords.confirmPassword}
                                onChange={handlePasswordChange}
                                required
                                minLength="8"
                                autoComplete="new-password"
                            />
                        </div>

                        <button
                            type="submit"
                            className={`${styles.btn} ${styles.btnPrimary}`}
                            disabled={isUpdating}
                        >
                            {isUpdating ? (
                                <>
                                    <div className={styles.buttonSpinner}></div>
                                    Saving...
                                </>
                            ) : (
                                <>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                        <path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"></path>
                                        <polyline points="17 21 17 13 7 13 7 21"></polyline>
                                        <polyline points="7 3 7 8 15 8"></polyline>
                                    </svg>
                                    Save New Password
                                </>
                            )}
                        </button>
                    </form>
                </div>
            )}
        </>
    );
};

export default PasswordChange;
